import { AuthContext } from "./authProvider/main";
import axios from "../utilities/axios";
import { useCallback, useContext, useEffect, useState } from "react";
import { Redirect, Route, Switch } from "react-router-dom";

type MasterPermissionProps = {
    children: React.ReactNode;
};

export const MasterPermission = ({ children }: MasterPermissionProps) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const authContext = useContext(AuthContext);

    const checkMaster = useCallback(() => {
        if (authContext.isAuthenticated !== true) {
            return;
        }

        axios.get("/api/v1/check-master").then((res) => {
            if (res?.data?.status === 200 && res?.data?.isMaster) {
                setIsAuthenticated(true);
            }
        })
    }, [authContext.isAuthenticated]);

    useEffect(() => {
        checkMaster();
    }, [checkMaster]);

    if (isAuthenticated !== true) {
        return <></>;
    }

    return <>{children}</>;
};

export const MasterRoute = ({ children, ...rest }: any) => {
    const authContext = useContext(AuthContext);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [loading, setLoading] = useState(true);

    const checkMaster = useCallback(() => {
        if (authContext.isAuthenticated !== true) {
            setLoading(false);
            return;
        }

        axios.get("/api/v1/check-master").then((res) => {
            if (res?.data?.status === 200 && res?.data?.isMaster) {
                setIsAuthenticated(true);
            }
        })
            .finally(() => {
                setLoading(false);
            });
    }, [authContext.isAuthenticated]);

    useEffect(() => {
        checkMaster();
    }, [checkMaster]);

    if (loading) {
        return <Route render={() => <></>} />;
    }

    return (
        <Route
            render={({ location }) => {
                if (!isAuthenticated) {
                    return (
                        <Redirect
                            to={{
                                pathname: authContext.isAuthenticated ? "/dashboard" : "/login",
                                state: { from: location },
                            }}
                        />
                    );
                }

                return <Switch>{children}</Switch>
            }}
        />
    );
};
